import api from './api';

const teamService = {
  /**
   * Get all team members for the current organization
   */
  async list() {
    const response = await api.get('/auth/users');
    return response.data;
  },

  /**
   * Create a new team member
   * @param {Object} memberData - already split into firstName/lastName
   */
  async create(memberData) {
    // Map frontend form data to API expected format
    const payload = {
      email: memberData.email,
      firstName: memberData.firstName,
      lastName: memberData.lastName,
      role: memberData.role,
      customRoleTitle: memberData.role === 'other' ? memberData.customRoleTitle : null,
      accessLevel: memberData.accessLevel,
      department: memberData.department,
      phone: memberData.phone || null,
      certifications: memberData.certifications || [],
      permissions: memberData.permissions || {},
      inviteMode: memberData.inviteMode || 'invite',
    };

    // Only send a password when the admin chose to set one now
    if (payload.inviteMode === 'set_password') {
      payload.password = memberData.password;
    }

    const response = await api.post('/auth/users', payload);
    return response.data;
  },

  /**
   * Update an existing team member. Accepts any subset of the editable fields.
   */
  async update(id, memberData) {
    const response = await api.patch(`/auth/users/${id}`, memberData);
    return response.data;
  },

  /**
   * Deactivate a team member (soft delete - keeps history)
   */
  async deactivate(id) {
    const response = await api.delete(`/auth/users/${id}`);
    return response.data;
  },

  /**
   * Reactivate a previously deactivated team member
   */
  async reactivate(id) {
    const response = await api.patch(`/auth/users/${id}`, { isActive: true });
    return response.data;
  },

  /**
   * Regenerate and resend the account setup link
   */
  async resendInvite(id) {
    const response = await api.post(`/auth/users/${id}/resend-invite`);
    return response.data;
  },
};

export default teamService;
